import React from 'react';
import {Link} from 'react-router-dom';
import About from '../../assets/images/lg-s.png';
import {FaImages} from 'react-icons/fa';
import Gallery from '../../models/gallery.model';
import { lang } from '../../config/app.config';

interface galleryInterface {
  gallery:Gallery
}

const GalleryList:React.FC<galleryInterface> = (props)=>{

  const {gallery} = props;

return(
  <div className="ecn-blog-card">
    <div className="ecn-blog-card--img">
      <img src={gallery.children && gallery.children.length? gallery.children[0].value:About} alt="" />
      <div className="overlay">
        <Link to={'/'+lang+"/gallery/"+gallery.key}><FaImages className="icon"/></Link>
      </div>
    </div>
  
    <div className="ecn-blog-card--details">
      <Link to={'/'+lang+"/gallery/"+gallery.key}>
        <h3 className="text-15-primary p-05 text-center" 
        title={gallery.name}
        >
          {gallery.name}
        </h3>
      </Link>
    </div>
  </div>
)
} 

export default GalleryList;